export const FETCH_HIELOCOS = 'FETCH_HIELOCOS';
export const FETCH_HIELOCOS_START_LOADING = 'FETCH_HIELOCOS_START_LOADING';
export const FETCH_HIELOCOS_FINISH_LOADING = 'FETCH_HIELOCOS_FINISH_LOADING';
export const FETCH_HIELOCOS_SUCCESS = 'FETCH_HIELOCOS_SUCCESS';
export const FETCH_HIELOCOS_NEXT_PAGE = 'FETCH_HIELOCOS_NEXT_PAGE';
export const FETCH_HIELOCOS_ERROR = 'FETCH_HIELOCOS_ERROR';
export const ADD_HIELOCO = 'ADD_HIELOCO';
export const DELETE_HIELOCO = 'DELETE_HIELOCO';
